import React from "react";
import { SliderItem } from "../../../../types";

interface CarouselPreviewCaptionProps {
    item: SliderItem;
    isMobileView: boolean;
}

export const CarouselPreviewCaption: React.FC<CarouselPreviewCaptionProps> = ({
    item,
    isMobileView,
}) => {
    const useMobileAlign = isMobileView && !!item?.useMobileAlignment;

    const horizontalAlignment = useMobileAlign
        ? (item?.horizontalAlignmentMobile || item?.horizontalAlignment || "center")
        : (item?.horizontalAlignment || "center");

    const verticalAlignment = useMobileAlign
        ? (item?.verticalAlignmentMobile || item?.verticalAlignment || "center")
        : (item?.verticalAlignment || "center");

    return (
        <div className={`carousel-caption alignment-${horizontalAlignment} vertical-${verticalAlignment}`}>
            <div className="carousel-caption__content">
                {item.h2?.text?.trim() && (
                    <h2 style={{ color: item.h2?.color || "inherit" }}>
                        {item.h2.text}
                    </h2>
                )}

                {item.logo && (
                    <img
                        className="carousel-logo"
                        src={item.logo}
                        alt="Logo"
                    />
                )}

                {item.p?.text?.trim() && (
                    <p
                        style={{ color: item.p.color || "inherit" }}
                        className={item.showButton ? "has-button" : ""}
                    >
                        {item.p.text}
                    </p>
                )}

                {item.showButton && (
                    <div
                        className="btn-carousel"
                        style={{
                            background: item.buttonBackgroundColor || "#000000",
                            color: item.buttonTextColor || "#ffffff",
                        }}
                    >
                        {item.a}
                    </div>
                )}
            </div>
        </div>
    );
};
